import { useArenaStore } from '../store'

export function Crosshair() {
  const isPlaying          = useArenaStore((s) => s.isPlaying)
  const nearWaitingStation = useArenaStore((s) => s.nearWaitingStation)

  if (!isPlaying) return null

  const scale = nearWaitingStation ? 1.4 : 1

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    >
      <div
        data-testid="crosshair-inner"
        data-swelled={nearWaitingStation ? 'true' : 'false'}
        style={{ transform: `scale(${scale})`, transition: 'transform 0.15s ease', position: 'relative' }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <line x1="12" y1="2"  x2="12" y2="8"   stroke="white" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="12" y1="16" x2="12" y2="22"  stroke="white" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="2"  y1="12" x2="8"  y2="12"  stroke="white" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="16" y1="12" x2="22" y2="12"  stroke="white" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="12" cy="12" r="1.2" fill="white" />
        </svg>
        {nearWaitingStation && (
          <span
            data-testid="crosshair-e-label"
            style={{
              position: 'absolute',
              top: '-1.1rem',
              left: '50%',
              transform: 'translateX(-50%)',
              fontFamily: "'Nunito', system-ui, sans-serif",
              fontSize: '0.7rem',
              fontWeight: 900,
              color: '#fbbf24',
              letterSpacing: '0.05em',
              whiteSpace: 'nowrap',
              textShadow: '0 1px 4px rgba(0,0,0,0.6)',
            }}
          >
            E
          </span>
        )}
      </div>
    </div>
  )
}
